module.exports = __webpack_public_path__ + "img/home-icon-org.8babb2a9.png";